import React from 'react';

const skillLevels = [
  {
    elo: 1000,
    title: 'Débutant absolu',
    description: [
      'Connaissances superficielles ou inexistantes.',
      'Capable de reconnaître certains concepts de base mais ne les comprend pas encore.',
    ],
  },
  {
    elo: 1200,
    title: 'Débutant avancé',
    description: [
      'Comprend les principes fondamentaux et quelques concepts clés.',
      'Peut résoudre des problèmes simples ou répondre à des questions directes avec une aide minimale.',
    ],
  },
  {
    elo: 1400,
    title: 'Intermédiaire',
    description: [
      'Connaissance fonctionnelle des bases du domaine.',
      'Capable d’appliquer des concepts simples de manière autonome.',
      'Commence à reconnaître les erreurs courantes ou les lacunes dans les réponses.',
    ],
  },
  {
    elo: 1600,
    title: 'Compétent',
    description: [
      'Bonne maîtrise des concepts fondamentaux et introduction aux notions avancées.',
      'Capable de résoudre des problèmes complexes avec une logique structurée.',
      'Peut expliquer les bases à d’autres personnes.',
    ],
  },
  {
    elo: 1800,
    title: 'Avancé',
    description: [
      'Solide compréhension théorique et pratique du domaine.',
      'Résolution de problèmes complexes avec des réponses détaillées et justifiées.',
      'Connaît et anticipe les pièges ou erreurs fréquentes.',
    ],
  },
  {
    elo: 2000,
    title: 'Expert',
    description: [
      'Maîtrise des concepts avancés, capable d’enseigner ou de guider d’autres personnes.',
      'Capacité à évaluer et optimiser les solutions à des problèmes complexes.',
      'Connaissance approfondie des meilleures pratiques dans le domaine.',
    ],
  },
  {
    elo: 2200,
    title: 'Maître',
    description: [
      'Référence dans le domaine, capable de répondre aux questions complexes avec précision.',
      'Peut concevoir des solutions innovantes et anticiper les tendances futures.',
      'Niveau recherché pour les certifications de haut niveau ou les projets critiques.',
    ],
  },
  {
    elo: 2400,
    title: 'Expert international',
    description: [
      'Niveau d’élite, reconnu pour sa capacité à résoudre des problèmes complexes dans un contexte global.',
      'Expertise stratégique et compréhension des interrelations entre concepts avancés.',
      'Établit des normes et des standards dans le domaine.',
    ],
  },
];

const Instructions = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      {/* Section : But de l'application */}
      <section style={{ marginBottom: '30px' }}>
        <h1>But de l'Application</h1>
        <p>
          Cette application a pour objectif de mesurer votre niveau de compétence grâce au système de scoring Elo. Ce
          système, utilisé dans les échecs et d'autres domaines compétitifs, évalue votre niveau relatif en fonction de vos
          performances. Voici les principes clés :
        </p>
        <ul>
          <li>
            <strong>Elo :</strong> une valeur qui représente votre niveau. Plus votre Elo est élevé, plus vous êtes compétent.
          </li>
          <li>
            <strong>RD (Déviation) :</strong> une mesure de la précision de votre Elo. Une RD faible (par exemple, inférieur à 60)
            signifie que votre niveau est bien déterminé.
          </li>
        </ul>
      </section>

      {/* Section : Modalités d'utilisation */}
      <section style={{ marginBottom: '30px' }}>
        <h1>Modalités d'Utilisation</h1>
        <p>
          Pour utiliser l'application, suivez ces étapes :
        </p>
        <ol>
          <li><strong>Inscription :</strong> créez un compte avec un email "bidon" : aucun mail ne sera envoyé dans cette phase d'expérimentation</li>
          <li><strong>Connexion :</strong> connectez-vous pour accéder à votre profil et commencer le quiz.</li>
          <li><strong>Quiz :</strong> répondez à des questions pour faire évoluer votre Elo.</li>
        </ol>
        <p>
          Le test est conçu pour être continu. Vous pouvez répondre à autant de questions que vous le souhaitez, mais chaque
          question ne sera posée qu'une seule fois par jour. Votre niveau de compétence est fiable lorsque votre RD descend
          en dessous de 60 environ.
        </p>
      </section>

      {/* Section : Niveaux de compétence */}
      <section>
        <h1>Niveaux de Compétence</h1>
        {skillLevels.map((level) => (
          <div key={level.elo} style={{ marginBottom: '20px', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
            <h2>{level.elo} Elo : {level.title}</h2>
            <ul>
              {level.description.map((desc, index) => (
                <li key={index}>{desc}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Instructions;
